<!--
 * @Descripttion: 地块信息-垂直展示（流转）
 * @Author: juanjuanhui
 * @Date: 2022-04-15 11:00:18
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2022-04-15 11:40:05
-->
<template>
  <div class="content">
    <ul class="list">
      <li class="item">
        <div class="left-side">
          <i class="iconfont icon-tudiquanshu1"></i>
        </div>
        <div class="right-side">
          <p class="tit">土地权属</p>
          <p class="name">
            {{ curLandInfo.croplandVillGroupName }}
          </p>
        </div>
      </li>
      <li class="item">
        <div class="left-side">
          <i class="iconfont icon-a-1dikuaiweizhi"></i>
        </div>
        <div class="right-side">
          <p class="tit">地块位置</p>
          <p class="name">{{ curLandInfo.address }}</p>
        </div>
      </li>
      <li class="item">
        <div class="left-side">
          <i class="iconfont icon-jingyingquanguishu"></i>
        </div>
        <div class="right-side">
          <p class="tit">经营权归属</p>
          <p class="name">
            {{ curLandInfo.croplandFranchisedTypeName }}
          </p>
        </div>
      </li>
      <li class="item">
        <div class="left-side">
          <i class="iconfont icon-dikuaisuoshu"></i>
        </div>
        <div class="right-side">
          <p class="tit">经营主体</p>
          <p class="name">
            {{ curLandInfo.croplandProprietor }}
          </p>
        </div>
      </li>
      <li class="item">
        <div class="cell">
          <div class="left-side">
            <i class="iconfont icon-dikuaibianhao"></i>
          </div>
          <div class="right-side">
            <p class="tit">地块编号</p>
            <p class="name">{{ curLandInfo.croplandId }}</p>
          </div>
        </div>
        <div class="cell">
          <div class="left-side">
            <i class="iconfont icon-tudishuxing"></i>
          </div>
          <div class="right-side">
            <p class="tit">土地属性</p>
            <p class="name">{{ curLandInfo.croplandTypeName }}</p>
          </div>
        </div>
      </li>
      <li class="item">
        <div class="cell">
          <div class="left-side">
            <i class="iconfont icon-dikuaizhouchang"></i>
          </div>
          <div class="right-side">
            <p class="tit">地块周长</p>
            <p class="name">{{ curLandInfo.croplandPerimeter }}米</p>
          </div>
        </div>
        <div class="cell">
          <div class="left-side">
            <i class="iconfont icon-dikuaimianji"></i>
          </div>
          <div class="right-side">
            <p class="tit">地块面积</p>
            <p class="name">{{ curLandInfo.croplandArea }}亩</p>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "MapLandInfoHorizontal",
  data() {
    return {};
  },
  props: {
    curLandInfo: {
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
.list {
  .item {
    display: flex;
    align-items: center;
    min-height: 70px;
    border-bottom: 1px solid #3d403b;
    .left-side {
      margin: 10px 20px;
      i {
        color: #2ac9cf;
        font-size: 32px;
      }
    }
    .right-side {
      flex: 1;
      margin: 10px 0;
      .tit {
        font-size: 14px;
        color: #2ac9cf;
      }
      .name {
        font-size: 16px;
        color: #d0e7e8;
      }
    }
    .cell {
      display: flex;
      align-items: center;
      width: 50%;
      min-height: 70px;
      &:first-child {
        border-right: 1px solid #3d403b;
      }
      .left-side {
        margin: 0 10px;
      }
    }
  }
}
</style>
